<template>
    <div class="or-admin-radio flex-row">
        <p class="title">{{options.title}}</p>
        <p class="radio hover-pointer" @click="select(0)" :style="`color: ${options.selected_variant === 0 ? 'green' : 'gray'}`">{{options.variants[0]}}</p>
        <p class="radio hover-pointer" @click="select(1)" :style="`color: ${options.selected_variant === 1 ? 'green' : 'gray'}`">{{options.variants[1]}}</p>
    </div>
</template>

<script>
export default {
    props: {
        options: Object
    },
    methods: {
        select(index) {
            this.options.selected_variant = index;
            this.$emit('unsaved');
        }
    }
}
</script>

<style scoped>
    .radio {
        font-size: 14px;
        line-height: 16px;
        margin-left: 15px;
    }
    .title {
        font-size: 14px;
        line-height: 16px;
    }
</style>